
export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#0A1628] mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p className="text-sm text-gray-500">Última actualización: 6 de febrero de 2026</p>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">1. Información General</h2>
            <p>
              En cumplimiento con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018, 
              de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), 
              PreBedAI informa a los usuarios del sitio web sobre su política de protección de datos de carácter personal.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">2. Responsable del Tratamiento</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Identidad:</strong> PreBedAI</li>
              <li><strong>Dirección postal:</strong> [Dirección de la empresa]</li>
              <li><strong>Correo electrónico:</strong> info@prebedai.com</li>
              <li><strong>Sitio web:</strong> https://prebedai.com</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">3. Datos que Recopilamos</h2>
            <p>Recopilamos los siguientes tipos de datos personales:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Datos de identificación:</strong> Nombre completo, correo electrónico</li>
              <li><strong>Datos profesionales:</strong> Hospital/Centro, cargo, teléfono de contacto</li>
              <li><strong>Datos de navegación:</strong> Dirección IP, cookies, datos de uso del sitio web</li>
              <li><strong>Datos de comunicación:</strong> Mensajes enviados a través de formularios de contacto</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">4. Finalidad del Tratamiento</h2>
            <p>Tratamos sus datos personales para las siguientes finalidades:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Gestionar solicitudes de información y contacto</li>
              <li>Procesar solicitudes de programa piloto</li>
              <li>Enviar comunicaciones comerciales (con su consentimiento)</li>
              <li>Mejorar nuestros servicios y la experiencia del usuario</li>
              <li>Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">5. Base Legal del Tratamiento</h2>
            <p>El tratamiento de sus datos se basa en:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Consentimiento:</strong> Al enviar formularios de contacto</li>
              <li><strong>Interés legítimo:</strong> Para mejorar nuestros servicios</li>
              <li><strong>Ejecución de contrato:</strong> Para gestionar relaciones comerciales</li>
              <li><strong>Obligación legal:</strong> Para cumplir con requisitos legales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">6. Conservación de Datos</h2>
            <p>
              Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad 
              para la que se recabaron y para determinar las posibles responsabilidades que se pudieran derivar 
              de dicha finalidad y del tratamiento de los datos. Una vez que los datos dejen de ser necesarios 
              para estos fines, serán suprimidos con medidas de seguridad adecuadas.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">7. Destinatarios de los Datos</h2>
            <p>Sus datos pueden ser compartidos con:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Proveedores de servicios:</strong> Para hosting, email marketing, análisis</li>
              <li><strong>Autoridades:</strong> Cuando sea legalmente requerido</li>
              <li><strong>Terceros:</strong> Solo con su consentimiento expreso</li>
            </ul>
            <p className="mt-4">
              No se realizan transferencias internacionales de datos fuera del Espacio Económico Europeo, 
              salvo que se utilicen servicios de proveedores que cumplan con las garantías adecuadas de protección.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">8. Derechos del Usuario</h2>
            <p>Como titular de los datos, usted tiene derecho a:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Acceso:</strong> Conocer qué datos tratamos sobre usted</li>
              <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos</li>
              <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos</li>
              <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento</li>
              <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
              <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos</li>
              <li><strong>Revocación:</strong> Retirar el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-4">
              Para ejercer estos derechos, puede contactarnos en: <a href="mailto:info@prebedai.com" className="text-[#6D28D9] hover:underline">info@prebedai.com</a>
            </p>
            <p className="mt-2">
              También tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) 
              si considera que se han vulnerado sus derechos: <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-[#6D28D9] hover:underline">www.aepd.es</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">9. Seguridad</h2>
            <p>
              PreBedAI ha adoptado medidas técnicas y organizativas de seguridad apropiadas para proteger 
              los datos personales contra el tratamiento no autorizado o ilícito y contra su pérdida, 
              destrucción o daño accidental.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#0A1628] mt-8 mb-4">10. Modificaciones</h2>
            <p>
              PreBedAI se reserva el derecho de modificar la presente Política de Privacidad para adaptarla 
              a novedades legislativas o jurisprudenciales, así como a prácticas de la industria. 
              Las modificaciones serán comunicadas con antelación suficiente.
            </p>
          </section>

          <section className="mt-12 p-6 bg-gray-50 rounded-lg">
            <h3 className="text-xl font-bold text-[#0A1628] mb-4">Contacto</h3>
            <p>
              Para cualquier duda o consulta sobre esta Política de Privacidad, puede contactarnos en:
            </p>
            <ul className="mt-4 space-y-2">
              <li><strong>Email:</strong> <a href="mailto:info@prebedai.com" className="text-[#6D28D9] hover:underline">info@prebedai.com</a></li>
              <li><strong>Web:</strong> <a href="https://prebedai.com" className="text-[#6D28D9] hover:underline">https://prebedai.com</a></li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
